import { useMergePartsMutation } from '../../../../graphql'
import { useShowSuccess, useShowError } from 'hooks/useToast'

export default function useMergePartsHandler() {
	const [ mergeParts ] = useMergePartsMutation()
	const showSuccess = useShowSuccess()
	const showError = useShowError()

	// Resolves whether the merge succeeded; the backend reports some failures as success: false rather than an error.
	return async( goodPartId: number, duplicatePartId: number ): Promise<boolean> => {
		const result = await mergeParts( {
			variables: {
				goodPartId,
				duplicatePartId,
			},
		} )
		if ( result.data?.mergeParts?.success ) {
			showSuccess( `mergePartsSuccess${Date.now()}`, result.data?.mergeParts?.message ?? 'Success!' )
			return true
		}
		showError( `mergePartsError${Date.now()}`, result.data?.mergeParts?.message ?? 'Sorry, an error occurred' )
		return false
	}
}
